import { inject, Injectable } from '@angular/core';
import { CanMatch, CanMatchFn, Route, Router, UrlSegment, UrlTree } from '@angular/router';
import {
    isExternalStoreHost,
    isServicesBoHost,
    isTenantAppHost,
} from '../services-host.util';

function redirectTree(target: string): UrlTree {
    const router = inject(Router);
    return target.startsWith('/') ? router.parseUrl(target) : router.createUrlTree([target]);
}

/** Host match + redirect in canMatch (redirectTo cannot be combined with canMatch on the same route). */
export function hostRedirectCanMatch(hostCheck: () => boolean, target: string): CanMatchFn {
    return (): boolean | UrlTree => {
        if (!hostCheck()) {
            return false;
        }
        return redirectTree(target);
    };
}

export const servicesBoRootRedirectCanMatch = hostRedirectCanMatch(isServicesBoHost, 'dashboard');
export const tenantAppRootRedirectCanMatch = hostRedirectCanMatch(isTenantAppHost, 'dashboard');
export const servicesBoWildcardRedirectCanMatch = hostRedirectCanMatch(isServicesBoHost, 'dashboard');
export const tenantAppWildcardRedirectCanMatch = hostRedirectCanMatch(isTenantAppHost, 'dashboard');
export const storeHostWildcardRedirectCanMatch = hostRedirectCanMatch(isExternalStoreHost, '/');
export const servicesBoClientsRedirectCanMatch = hostRedirectCanMatch(isServicesBoHost, '/store/clients');

@Injectable({ providedIn: 'root' })
export class ServicesBoHostMatchGuard implements CanMatch {
    canMatch(_route: Route, _segments: UrlSegment[]): boolean {
        return isServicesBoHost();
    }
}

/** @deprecated Use ServicesBoHostMatchGuard */
@Injectable({ providedIn: 'root' })
export class ServicesHostMatchGuard extends ServicesBoHostMatchGuard {}

@Injectable({ providedIn: 'root' })
export class StoreHostMatchGuard implements CanMatch {
    canMatch(_route: Route, _segments: UrlSegment[]): boolean {
        return isExternalStoreHost();
    }
}

@Injectable({ providedIn: 'root' })
export class TenantAppHostMatchGuard implements CanMatch {
    canMatch(_route: Route, _segments: UrlSegment[]): boolean {
        return isTenantAppHost();
    }
}

@Injectable({ providedIn: 'root' })
export class NotServicesBoHostMatchGuard implements CanMatch {
    canMatch(_route: Route, _segments: UrlSegment[]): boolean {
        return !isServicesBoHost();
    }
}

/** @deprecated Use NotServicesBoHostMatchGuard */
@Injectable({ providedIn: 'root' })
export class NotServicesHostMatchGuard extends NotServicesBoHostMatchGuard {}
